import * as viewModels from '../../view/view-models';
import * as actions from '../actions/area-collection';
import { Lookup } from '../../../../shared/models';

import * as _ from 'lodash';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  items: Array<viewModels.ListItem>;
  pristine: boolean;
  lookup: Lookup;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  items: [],
  pristine: false,
  lookup: new Lookup(),
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return {
        ...state,
        isLoading: true,
        lookup: _.cloneDeep(action.payload.lookup),
        pristine: false,
      };
    }

    case actions.LOAD_SUCCESS: {
      const lookup = _.cloneDeep(state.lookup);
      lookup.total = _.cloneDeep(action.payload.total);
      return {
        isLoaded: true,
        isLoading: false,
        lookup,
        items: _.cloneDeep(action.payload.items),
        pristine: true,
      };
    }

    case actions.LOAD_FAIL: {
      const lookup = _.cloneDeep(state.lookup);
      return {
        ...initialState,
        lookup,
        isLoaded: true,
      };
    }

    case actions.ADD_AREA: {
      return {
        ...state,
        isLoaded: false,
        isLoading: true,
        pristine: false,
      };
    }

    case actions.ADD_AREA_FAIL: {
      return {
        ...state,
        isLoaded: false,
        isLoading: false,
        pristine: false,
      };
    }

    case actions.ADD_AREA_SUCCESS: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        pristine: true,
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItems = (state: State) => state.items;
export const getPristine = (state: State) => state.pristine;
export const getLookup = (state: State) => state.lookup;
